import { getCMSObject } from 'sg-ui-components';

const UNEXPECTED_ERROR =
    'Unexpected Server Error. Please try again. If you still see the error, then please submit <a href="/feedback#contact">Feedback</a> form for further assistance.';

export const errorMessage = (code) => {
    const cmsErrorMessages = getCMSObject('data.messages.errorMessages.jsonBlock');
    return cmsErrorMessages[code] || UNEXPECTED_ERROR;
};
